import {gql} from "@apollo/client";

export const signUpQueries = {
    clubAgency: gql`
        {
            teams{
                id
                name
                slogan
            }

            agencies{
                id
                name
            }
        }
    `,
};
